import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { useSelectedProvider } from 'hooks/useSelectedProvider';
import { connectFC } from 'utils/connectFC';

import { EmptyPromotionsListFC, EmptyPromotionsListFCProps } from './EmptyPromotionsListFC';

const useStrings = (): EmptyPromotionsListFCProps['strings'] => {
  const intl = useIntl();

  return useMemo(
    () => ({
      title: intl.formatMessage({ id: 'components.EmptyPromotionsList.title' }),
      subtitle: intl.formatMessage({ id: 'components.EmptyPromotionsList.subtitle' }),
      addPromotions: intl.formatMessage({ id: 'components.EmptyPromotionsList.addPromotions' }),
    }),
    [intl],
  );
};

interface EmptyPromotionsListProps {
  onClick: () => void;
}

export const EmptyPromotionsList = connectFC(
  EmptyPromotionsListFC,
  ({ onClick }: EmptyPromotionsListProps) => {
    const strings = useStrings();
    const selectedProvider = useSelectedProvider();

    return {
      onClick,
      strings,
      canSelfAssignCampaigns: Boolean(selectedProvider?.permissions.selfAssignCampaigns),
    };
  },
);
